let common = require('./modules/common.js');

let _internals = {
    animatedElements: null,
    animatedElementsCount: 0,
    observer: null,
    techSlider: null,
    clientsSlider: null,
    addAnimations: function() {
        _internals.animatedElements = document.querySelectorAll('[data-animation-type]');
        _internals.animatedElementsCount = _internals.animatedElements.length;

        if (!('IntersectionObserver' in window)) {
            _internals.applyAnimationsImmediate();
        } else {
            // It is supported, load the images
            _internals.observer = new IntersectionObserver(_internals.animateElement, {
                rootMargin: '150px 0px',
                threshold: 0.01
            });

            // foreach() is not supported in IE
            for (let i = 0; i < _internals.animatedElements.length; i++) {
                _internals.observer.observe(_internals.animatedElements[i]);
            }
        }
    },
    animateElement: function (entries) {

        if (_internals.animatedElementsCount === 0 && _internals.observer) {
            _internals.observer.disconnect();
            return;
        }

        // Loop through the entries
        for (let i = 0; i < entries.length; i++) {
            let entry = entries[i];
            // Are we in viewport?
            if (entry.intersectionRatio > 0) {
                _internals.animatedElementsCount--;

                // Stop watching and load the image
                _internals.observer.unobserve(entry.target);

                let animationType = entry.target.getAttribute('data-animation-type');
                entry.target.classList.add('animated');
                entry.target.classList.add(animationType);
            }
        }
    },
    applyAnimationsImmediate: function () {
        for (let i = 0; i < _internals.animatedElements; i++) {
            let animationType = _internals.animatedElements[i].getAttribute('data-animation-type');
            _internals.animatedElements[i].classList.add('animated');
            _internals.animatedElements[i].classList.add(animationType);
        }
    },
    initTechSlider: function (Swiper) {
        _internals.techSlider = new Swiper('#TechnologiesSlider', {
            autoplay: {
                delay: 3000,
            },
            loop: true,
            lazy: {
                loadPrevNext: true,
            },
            init: false,
            slidesPerView: 6,
            spaceBetween: 15,
            navigation: {
                nextEl: '#techNext',
                prevEl: '#techPrev',
            },
            a11y: {
                prevSlideMessage: 'Предыдущий слайд',
                nextSlideMessage: 'Следующий слайд',
            },
            breakpoints: {
                559: {
                    slidesPerView: 2,
                    centeredSlides: true,
                },
                991: {
                    slidesPerView: 3,
                },
                1199: {
                    slidesPerView: 4,
                }
            }

        });

        common.observeSlider('TechnologiesSlider', _internals.techSlider)
    },
    initClientsSlider: function (Swiper) {
        _internals.clientsSlider = new Swiper('#ClientsSlider', {
            autoplay: {
                delay: 3000,
            },
            loop: true,
            lazy: {
                loadPrevNext: true,
            },
            init: false,
            slidesPerView: 5,
            spaceBetween: 30,
            navigation: {
                nextEl: '#clientsNext',
                prevEl: '#clientsPrev',
            },
            a11y: {
                prevSlideMessage: 'Предыдущий слайд',
                nextSlideMessage: 'Следующий слайд',
            },
            breakpoints: {
                419: {
                    slidesPerView: 1,
                    centeredSlides: true
                },
                991: {
                    slidesPerView: 2,
                },
                1199: {
                    slidesPerView: 3,
                }
            }

        });

        common.observeSlider('ClientsSlider', _internals.clientsSlider)
    },
    checkEmbeddedForm: function () {
        let form = document.getElementById('enquiry-embedded');

        if (form == null) {
            return;
        }

        import(/* webpackChunkName: "validation" */'./modules/validation').then(function (validation) {
            let fv = validation.fv(
                form,
                {
                    plugins: {
                        declarative: new validation.DeclarativePlugin(),
                        submitButton: new validation.SubmitButtonPlugin(),
                        bootstrap: new validation.BootstrapPlugin(),
                        trigger: new validation.TriggerPlugin(),
                        recaptcha: new validation.RecaptchaPlugin({
                            element: form.getAttribute('data-fvp-recaptcha___element'),
                            language: form.getAttribute('data-fvp-recaptcha___language'),
                            message: form.getAttribute('data-fvp-recaptcha___message'),
                            siteKey: form.getAttribute('data-fvp-recaptcha___site-key'),
                            theme: form.getAttribute('data-fvp-recaptcha___theme'),
                            size: form.getAttribute('data-fvp-recaptcha___size'),
                            badge: form.getAttribute('data-fvp-recaptcha___badge')
                        }),
                    }
                }
            ).on('core.form.valid', function () {
                common.submitForm(fv.getFormElement()).then(function (response) {
                    $(form).html(response.message);
                });
            });
        });
    }
};

_internals.addAnimations();

if (document.querySelectorAll('.swiper').length) {
    import(
        /* webpackChunkName: "swiper" */
        'swiper').then(function (module) {
        _internals.initClientsSlider(module.default);
        _internals.initTechSlider(module.default);
    }, function (e) {
        console.log('Unable to load swiper library' + e.message);
        throw new Error('Unable to load swiper library' + e.message);
    });
}

_internals.checkEmbeddedForm();

